import styled from "@emotion/styled";
import { createRef, forwardRef, RefObject, useEffect, useMemo, useRef } from "react";
import _ from "lodash"
import { useWindowSize } from "react-use"

export const HiloWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-left: 20px;
    margin-right: 20px;
`

const Path = styled.path`
    z-index: 3;
    will-change: transition, stroke-dasharray;
`
const StyledSvg = styled.svg`
    position: absolute;
`


type LineSectionConfig = {
    sectionEnd: number;
    sectionLength: number;
}

const configs: LineSectionConfig[] = [
    {
        sectionEnd: 1076,
        sectionLength: 70000,
    },
    {
        sectionEnd: 2352,
        sectionLength: 12000,
    },
    {
        sectionEnd: 4200,
        sectionLength: 7000,
    },
    {
        sectionEnd: 5685,
        sectionLength: 4500,
    },
    {
        sectionEnd: 6055,
        sectionLength: 1800,
    },
    {
        sectionEnd: 6141,
        sectionLength: 800,
    },
    {
        sectionEnd: 6241,
        sectionLength: 900,
    },
    {
        sectionEnd: 7200,
        sectionLength: 3100,
    },
    {
        sectionEnd: 7700,
        sectionLength: 1600,
    },
    {
        sectionEnd: 7851,
        sectionLength: 1200,
    },
    {
        sectionEnd: 8385,
        sectionLength: 1800,
    },
    {
        sectionEnd: 8585,
        sectionLength: 500,
    },
    {
        sectionEnd: 9000,
        sectionLength: 800,
    },
    {
        sectionEnd: 9825,
        sectionLength: 3000,
    },
    {
        sectionEnd: 10332,
        sectionLength: 3000,
    },
    {
        sectionEnd: 12000,
        sectionLength: 3000,
    },
    {
        sectionEnd: 13240,
        sectionLength: 2000,
    },
    {
        sectionEnd: 14006,
        sectionLength: 1500,
    },
]//

const configs2: LineSectionConfig[] = [
    {
        sectionEnd: 0.0806,
        sectionLength: 0.3656,
    },
    {
        sectionEnd: 0.1543,
        sectionLength: 0.062,
    },
    {
        sectionEnd: 0.2756,
        sectionLength: 0.0366,
    },
    {
        sectionEnd: 0.373,
        sectionLength: 0.0235,
    },
    {
        sectionEnd: 0.3973,
        sectionLength: 0.0094,
    },
    {
        sectionEnd: 0.4029,
        sectionLength: 0.0026,
    },
    {
        sectionEnd: 0.4095,
        sectionLength: 0.0047,
    },
    {
        sectionEnd: 0.4724,
        sectionLength: 0.0162,
    },
    {
        sectionEnd: 0.5052,
        sectionLength: 0.0084,
    },
    {
        sectionEnd: 0.5151,
        sectionLength: 0.0063,
    },
    {
        sectionEnd: 0.5501,
        sectionLength: 0.0094,
    },
    {
        sectionEnd: 0.5632,
        sectionLength: 0.0026,
    },
    {
        sectionEnd: 0.5905,
        sectionLength: 0.0042,
    },
    {
        sectionEnd: 0.6446,
        sectionLength: 0.0157,
    },
    {
        sectionEnd: 0.6779,
        sectionLength: 0.0157,
    },
    {
        sectionEnd: 0.7873,
        sectionLength: 0.0157,
    },
    {
        sectionEnd: 0.8687,
        sectionLength: 0.0304,
    },
    // {
    //     sectionEnd: 0.9189,
    //     sectionLength: 0.078,
    // },
]

type LineSectionColorConfig = {
    atLengths: number[];
    color: string;
}

const colorConfigs: LineSectionColorConfig[] = [
    {
        atLengths: [0, 85932],
        color: "#9fcd39"
    },
    {
        atLengths: [85932, 92850],
        color: "white"
    },
    {
        atLengths: [92850, 119715],
        color: "#9fcd39"
    },
    {
        atLengths: [119715, 191448],
        color: "white"
    },
    {
        atLengths: [129904, 191448],
        color: "#9ecb3a"
    }
]



const sumSectionEnd = (index: number, pathHeight: number) => configs2.slice(0, index).reduce((prev, current) => prev + ((current.sectionEnd * pathHeight - prev)), 0)
const sumSectionLength = (index: number, pathLength: number) => configs2.slice(0, index).reduce((prev, current) => prev + (current.sectionLength * pathLength), 0)


interface IProps {
    width: number;
    height: number;
}

export const Hilo: React.FC<IProps> = ({ width, height }) => {

    const wrapperRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        const wrapperEl = _.get(wrapperRef, "current", null)
        if (wrapperEl) {
            //@ts-ignore
            const pathLength = wrapperEl.firstChild?.firstChild?.getTotalLength();
            const pathHeight = height//16280//Math.min(height, 16280)

            const maxScrollTop = pathHeight - window.innerHeight;
            const scrollAdvantage = 100

            const renderPath = () => {
                let length = 0;
                let percentDone = 0;
                const scrollPoint = window.scrollY + scrollAdvantage
                let sectionIndex = 0
                while (sectionIndex < configs2.length && configs2[sectionIndex].sectionEnd * pathHeight < scrollPoint) {
                    sectionIndex++
                }
                const sumSectionHeight = sumSectionEnd(sectionIndex, pathHeight)
                let percentDivision = sectionIndex > 0 ? (maxScrollTop - sumSectionHeight) : configs2[sectionIndex].sectionEnd * pathHeight
                percentDone = scrollPoint / percentDivision
                length = sectionIndex > 0 ? (sumSectionLength(sectionIndex, pathLength) + (percentDone * configs2[sectionIndex - 1].sectionLength * pathLength)) : (percentDone * configs2[sectionIndex].sectionLength * pathLength)

                console.log("alternative:", { sumSectionHeight, percentDivision, sectionIndex, length, percentDone, pathLength, maxScrollTop, scroll: window.scrollY, scrollPoint })

                //@ts-ignore
                for (const [index, svg] of Array.from(wrapperEl.children).entries()) {
                    let strokeDasharrayValue = ""
                    let transitionValue = ""
                    if (length > colorConfigs[index].atLengths[1]) {
                        strokeDasharrayValue = [colorConfigs[index].atLengths[1] - colorConfigs[index].atLengths[0], pathLength].join(' ')
                    }
                    else if (length > colorConfigs[index].atLengths[0]) {
                        //@ts-ignore
                        strokeDasharrayValue = [Math.max(length - colorConfigs[index].atLengths[0], 0), pathLength].join(' ');
                        transitionValue = "stroke-dasharray 300ms linear"
                    }
                    else {
                        strokeDasharrayValue = [0, pathLength].join(' ')
                    }
                    //@ts-ignore
                    if (svg.firstChild.style.strokeDasharray != strokeDasharrayValue) {
                        //@ts-ignore
                        svg.firstChild.style.strokeDasharray = strokeDasharrayValue
                    }
                    //@ts-ignore
                    if (svg.firstChild.style.transition != transitionValue) {
                        //@ts-ignore
                        svg.firstChild.style.transition = transitionValue
                    }
                }

            }
            renderPath()
            document.addEventListener("scroll", _.throttle(renderPath, 300))
            //document.addEventListener("scroll", renderPath)
        }

    }, [wrapperRef])

    //console.log({ pathWidth, width, width2: width - 200 })

    return <HiloWrapper ref={wrapperRef}>
        {colorConfigs.map(({ atLengths, color }, index) =>
            <StyledSvg width={width} height={height} preserveAspectRatio="none" viewBox={`0 0 1900.801 15241.912`} /*viewBox={`0 0 1900.801 15241.912`}*/>
                <Path id={`path-${index}`} strokeDasharray="0 191448.3125" d={pathCoords} transform="translate(0 -424.508)" fill="none" stroke={color} strokeDashoffset={-atLengths[0]} strokeWidth={7} />
                
            </StyledSvg>)}

    </HiloWrapper>
}

export default Hilo


const pathCoords = "M0,428.008H1803.7s52.884,7.047,52.884,64.871c0,32.435-34.429,55.7-52.884,55.7S519.144,550.346,90.96,549.993c-18.22-.015-25.487-16.58-25.487-23.962s6-26.639,24.071-26.639,1767.126.642,1776.76.642,20.541-14.117,20.541-25.355-9.969-23.282-23.282-23.282-1777.366-.344-1785.3-.344-33.576,9.628-33.082,37.526,25.884,35.8,33.082,35.8,1769.573.532,1778.318.532,39.723,5.873,39.723,43.907c0,30.4-31.289,40.982-39.723,40.982S60.659,611.4,58.091,611.4s-12.517-3.825-12.517-11.554,6.066-13.8,12.517-13.8,1796.242-6.37,1799.7-6.37,13.085,2.653,13.085,14.813c0,19.012-23.207,15.306-23.207,15.306L83.94,610.046c-3.981,0-20.985,4.936-20.985,25.676,0,12.593,13.787,20.244,20.985,20.244s1754.969.682,1756.868.682a5.738,5.738,0,0,1,5.113,5.843c0,3.823-2.612,5.113-5.113,5.113S88.22,668.28,85.066,668.28s-9.552,2.412-9.552,10.9,7.976,9.439,10.563,9.439l1754.731-.45c2.458,0,17.08,2.654,17.08,19.624s-12.9,20.871-17.08,21.08-1744.1.526-1750.236.526-14.316-5.235-14.316-16.508,9.605-14.608,14.316-14.608S1848.756,699.7,1852.511,699.7s25.9,5.677,24.617,34.63c-1,22.443-25.7,27.537-31.207,27.537S87.4,761.532,78.262,761.532,62.29,770.64,62.29,781.48s9.153,17.472,15.971,17.662,1755.565.266,1761.511.266,12.591-4.938,11.6-12.344-6.419-10.369-13.578-10.122S98.181,777.3,78.262,777.3,29.9,790.233,28.789,823.2s35.873,45.9,46.725,45.9,1745.421-.61,1764.258-.61,28.145-11.875,27.824-23.429-8.468-23.429-27.824-23.429-1739.347.247-1758.054.247-36.33,13.155-36.33,38.8S71.035,894.951,83.2,894.951s1758.4-1.111,1771.557-.469,33.7,11.554,32.416,35.946-19.9,33.378-32.416,33.7S83.951,955.14,75.514,955.14,40.76,962.2,40.76,989.161s26.822,31.453,34.754,31.132,1655.381-5.358,1664.022-5.358,33.082-3.95,33.329-28.391-16.294-31.354-33.329-31.6S66.916,929.491,66.916,929.491,1811.2,961.72,1817.463,962.137s18.358,5.007,17.106,19.61-18.358,12.1-23.782,12.1-1673.731-6.291-1691.716-6.291S81.2,1000.392,81.2,1025.107s21.83,34.859,37.872,34.341,1705.079,12.337,1708.6,12.337,10.8,1.193,10.8,8.8-8.915,8.356-10.8,8.356S66.658,1097.11,64.759,1097.11s-11.015.57-10.825-9.306,8.166-9.875,10.825-9.875,1795.5-2.26,1802.415-2.013,20.738,5.185,20,21.479-13.579,20.244-20,20.491-1802.244-.493-1811.873.248-22.219,7.627-22.219,26.417S51.09,1168,59.5,1168s1791.832-11.6,1797.091-11.451,23.227,5.7,23.812,23.812-13.148,24.25-23.812,24.4-1752.593-.975-1775.39.3-40.519,12.09-40.519,34.335,21.367,32.544,40.519,32.544,1772.568-25.66,1780.079-25.66,23.365,2.086,23.782,22.531-21.279,19.193-26.286,19.61-1777.414,12.1-1782,12.1-13.351,1.252-12.934,13.352S76.867,1324.3,81.2,1324.3s1752.958-12.934,1755.878-12.934,9.6,5.007,0,5.007-1704.732,14.144-1728.055,13.6-56.41,10.848-55.868,49.359,34.714,49.9,59.664,48.274,1759.052.864,1769.174,1.357,15.355,7.056,15.307,14.072-4.014,13.12-16.541,13.825S104.866,1443.1,94.141,1443.1s-14.3,17.875,0,16.683,1736.519,9.533,1742.937,9.533,13.84,11.917,0,13.108S92.35,1478.849,81.2,1478.849s-13.8,11.568,0,12.76,1732.907,7.056,1746.476,6.736,9.792,16.629,0,16.211-1709.358.919-1733.535.919-33.392,15.178-33.392,30.375.542,275.542,0,283.678.538,34.714,36.883,34.714,742.006.249,760.363.249,66,20.167,66,74.25-45.75,66.916-66,66.916-598.58-.917-612.33-.917-72.416-14.667-73.333-66,55-55.916,69.666-55.916H871.745c10.083,0,67.551,13.186,68.891,68.256,1.543,63.442-59.724,72.628-68.891,73.333s-620.439-1.247-629.746-1.247-69.666-8.663-69.666-78.106,96.157-68.343,122.193-68.343,588.508,3.8,594.474,3.8,51.637,14.563,51.637,55.868c22.137,0,607.926-1.627,633.961-1.627s133.431,35.256,136.686,127.465-.059,476.018-.059,509.385-25.025,148.957-148.957,147.766-903.278-4.767-919.962-2.383-65.88,11.722-65.88,72.382c-.642,61.3,57.771,67.72,74.46,67.72s582.541.3,613.458-.247,61.292-23.323,60.207-67.258-39.6-52.613-60.207-53.156-617.8-.542-640.579-.542-65.631,23.866-63.461,74.309,46.1,65.088,66.716,65.088,621.052.542,640.036,0,62.376-21.7,63.461-69.97-30.917-74.309-83.53-73.225-615.078,1.085-635.155,1.085-40.893,26.443-40.138,63.461c-18.984.542-376.428-1.085-393.243,1.085s-94.921,23.866-98.175,106.854-.167,1889.861-.167,1907.8,15.438,56.744,65.088,56.327,1317.624-2.086,1336.817-1.252,65.088,18.776,65.088,68.844-42.141,68.009-62.585,68.844-1116.517.417-1129.451.417-58-15.438-57.578-63,42.558-56.743,57.578-57.161,1134.041-.417,1144.889.417,63.837,12.517,62.585,65.923-38.385,72.181-62.585,72.6-1403.574-2.92-1416.091-2.086-56.744,12.1-58.83,68.843.834,884.536.834,892.88,5.424,59.247,61.333,60.082,751.438-1.251,763.538-.834,63.419,15.438,63,68.009-44.227,68.844-63,69.261-667.991,1.669-684.263.834-52.571-24.2-51.737-62.168,30.458-58.83,56.327-58.83,688.436.835,700.953,1.252,59.664,22.948,56.744,71.764-40.472,66.757-66.34,66.757-719.728-1.669-725.152-1.252-55.909,5.424-55.492,70.513,1.608,1456.565,1.638,1470.029,8.375,33.362,32.446,33.683,992.053-1.6,1003.287-1.6,73.818,14.443,72.214,79.6-61.3,77.349-76.386,77.349-850.515-2.567-857.9-2.247-71.893-13.159-69.646-74.781,64.511-59.055,69.646-59.055,875.228-.641,884.857.321,70.288,14.121,67.72,78.953-60.98,75.744-70.93,76.065-781.229-.193-781.229-.193l1.644,338.48s33.7-1.282,32.416,23.751-18.615,29.848-32.416,29.206-21.183-11.233-20.22-27.6,13.159-20.862,20.22-20.862,22.787,6.1,21.825,25.034S366.54,8343.4,353.686,8343.4s-29.527-13.8-25.355-36.588,30.811-26.96,30.811-26.96l.074,720.319s21.973,3.7,22.466,25.183-20,27.9-30.367,27.4-24.935-9.63-21.973-34.564,29.379-22.959,37.033-22.466,34.07,15.307,21.479,40-48.883,13.578-49.624-10.369c-.618-19.994,12.591-26.417,20.985-29.626,0,24.732-.743,406.889-.307,542.519,12.326,3.3,22.368,10.034,22.368,24.281s-8.419,30.437-31.409,27.037-25.095-32.056-15.542-42.9,32.218-19.752,51.323-2.267-6.638,51.322-32.866,39.827-14.272-47.838,6.127-48.084c-.137,21.856-.2,1015.19-.2,1027.5s14.5,54.723,59.921,54.449,1043.494.46,1056.779.46,76.584,12.5,78.928,80.49-59.391,81.273-71.113,82.055-1112.779.781-1124.515.781-64.875-16.412-63.312-71.9,47.669-71.113,67.987-71.113,1118.277,0,1133.124.782,73.458,16.411,71.895,85.18-67.206,78.928-85.18,78.928-1294.888-.781-1305.047,0-53.14,14.066-52.358,59.392-.781,363.381,0,373.54,6.252,54.7,58.61,54.7,1291.762-3.125,1305.828-2.344,74.239,10.94,77.365,82.054-59.391,81.272-77.365,82.054-1112.806,0-1124.528.781-71.113-12.5-68.769-69.55,42.2-72.677,68.769-73.458,1104.21.781,1115.932.781,75.021,22.662,72.676,85.961-58.61,77.365-77.365,77.365-1105.472-1.318-1107.877-1.318-3.863,4.857,0,4.809,1294.648-3.493,1307.933-3.49,52.358,13.288,54.7,51.58,0,192.241,0,200.837-4.689,52.358-54.7,53.14-725.2.781-751.77.781-30.541,49.368,0,49.368h20.9c3.567,0,13.681,4.3,13.681,16.964s-9.576,15.87-13.681,15.87h-20.9c-3.18,0-20.691,4.315-20.691,25.993s18.673,23.257,20.691,23.257,19.8-.273,20.9,0,13.681-.008,13.681,17.785-15.049,15.869-17.511,15.869H925.255c-1.265,0-21.786.508-21.786,24.625s19.767,23.53,21.786,23.53h20.9c1.368,0,13.681,2.44,13.681,18.059s-13.681,16.417-15.87,16.417-17.444-.273-18.709,0-21.033,2.464-20.691,24.352,19.426,24.625,21.889,24.625h19.7c1.642,0,14.491,1.631,15.049,17.238s-16.143,16.964-18.606,16.964-450.285-.814-493.871.547-193,21.812-204.126,205.4,158.507,220.373,196.148,220.373H1451.181c63.318,0,208.651-50.795,208.651-199.273s-148.478-171.142-196.929-171.142-1069.341,1.837-1093.113,1.837-176.971,26.413-178.291,219.232,186.215,207.347,196.781,207.347,1005.034,0,1100.123-2.642,184.895-79.241,182.253-229.8-141.312-171.687-207.753-171.687-867.655-5.3-1014.178,0-191.193,165.612-191.193,210.251,47.595,216.327,191.193,216.327,953.527-.348,962.55,0,15.069,7.817,15.425,16.71-4.624,16.718-15.425,17.073-15.876-.356-20.5,0-20.275,6.048-20.275,26.322,21.342,22.408,26.322,22.408,10.766.355,14.453,0S1426.7,12703,1426.7,12719s-12,15.65-15.425,15.65-16.232-.355-20.5,0-19.563,4.624-20.275,25.966,20.986,24.188,26.322,24.188h14.453c2.62,0,15.781,3.557,15.425,15.65s-8.181,16.718-13.161,16.718-19.919-.355-22.765,0-20.986,4.624-20.275,27.033,21.7,22.766,26.322,22.409,12.545,0,14.453,0,16.492,1.777,15.425,17.784-11.287,16.007-15.425,16.362-15.876,0-20.5,0-20.986,6.046-20.275,24.9,16.362,23.12,22.409,23.12,7.921-.356,18.366,0,15.781,8.536,15.425,16.718.747,1192.839.747,1214.633-20.034,63.217-69.823,61.5-639.269-3.35-769.414-2.7-234.532,143.382-234.532,273.865,70.747,293.587,234.532,298.737,646.228,0,718.337,0,235.213-89.277,236.93-279.852-200.875-214.61-236.93-216.327-676.451-1.717-776.03,0-240.363,92.712-242.08,278.135,142.5,290.153,252.382,291.87,674.734,3.434,765.729,0,252.382-104.73,243.8-305.605-164.821-262.683-269.55-264.4-587.173-5.15-750.277,0-209.46,295.3-118.465,388.016,260.966,128.765,360.545-41.206-63.525-327.924-192.291-324.49-276.418,54.94-285,194.008,24.036,314.189,235.213,321.057,523.649,18.886,535.667,18.886,14.068,15.713-6.562,17.847-617.134,80.739-639.188,83.585-19.563,39.838,7.114,39.482,1278.158,17.784,1291.365,17.784,25.4,9.143,25.4,28.445-12.778,29.533-27.362,29.889-1538.827-21.893-1545.393-21.893-17.238-4.65-16.69-19.152,13.407-14.5,16.69-14.5,1616.231,10.944,1616.231,10.944l-1590.238,69.771s1563.7,22.163,1573.548,22.163,10.124,14.5,0,14.5-1606.381-22.71-1613.222-22.437-7.661,9.851,0,10.124,1562.056,22.437,1577.652,22.71,33.381,13.68,32.56,37.211-17.238,34.749-36.391,34.749-1505.418-21.342-1521.835-21.342-31.192,10.945-30.918,35.3,18.332,32.561,33.107,32.834,1562.6,35.843,1569.991,35.569,9.85-12.312-2.463-13.133-1641.09-122.839-1650.057-123.711-9.34-14.2,2.864-13.575,1561.088,41.972,1576.383,42.327,35.57,8.894,34.147,33.08-21.7,30.59-34.147,30.59-1549.416-22.054-1559.376-22.409-34.858,7.47-34.858,33.08,23.12,31.657,39.127,31.657,1551.369,22.055,1560,22.055,28.2,5.262,28.2,26.729-16.838,27.362-29.887,27.151-1517.21-23.023-1517.21-23.023l1536.931,3.006s-1551.959-21.642-1563.981-21.04-18.009,7.814-18.322,18.034a18.264,18.264,0,0,0,18.322,18.635c10.219,0,1568.342,21.04,1568.342,21.04s-1622.192,25.86-1627.453,25.86-11.076,3.755-11.221,12.611,8.905,10.12,13.115,10.33,1658.2,53.2,1658.2,53.2l-1617.033-98.03,1586.977,21.733s-1595,52.359-1601.566,53.454-4.069,9.451,2.463,9.029,1535.2-19.057,1547.823-19.057,21.165,4.208,21.4,16.23-6.976,18.635-26.212,18.635-1519.651-33.663-1519.651-33.663,1514.241,48.091,1534.679,49.293,15.629,20.438,0,20.438-1542.332-24.044-1558.042-23.443-39.755,3.605-37.952,39.674,32.461,31.859,54.7,31.259,1506.788,20.433,1526.264,22,26.7,10.94,26.212,25.788-6.736,21.1-35.65,21.881-1490.255-21.881-1516.825-21.881-41.418-17.192-41.759-40.636,16.752-37.739,41.759-38.406,1541.292,23.558,1541.292,23.558l-1578.8-96.9,1593.193,14.848"